/**
 * Get the environment variable
 * @param env - The environment variable
 * @param defaultEnv - The default environment variable
 * @returns The environment variable
 */
export function getEnv(env: string, defaultEnv?: string): string {
  const envVar = import.meta.env[env];
  if (!envVar) {
    if (defaultEnv) {
      return defaultEnv;
    }
    throw new Error(`Missing ${env} from environment variables`);
  }
  return envVar;
}
